import React from 'react';
import ModalsCreateEnvoi from './ModalsCreateEnvoi';
import ModalsActions from './ModalsActions';
import ModalsDetail from './ModalsDetail';

export default function Modals(props) {
  return (
    <>
      <ModalsCreateEnvoi {...props} />
      <ModalsActions {...props} />
      <ModalsDetail {...props} />
    </>
  );
}
